import { Injectable } from '@angular/core';

import { environment } from '@fb/environments';

@Injectable()
export class TranslationPathService {
  #path = `${environment.assetsUrl}/assets/i18n/`;

  setTranslationPath(path: string): void {
    if (path) {
      this.#path = path;
    }
  }

  getTranslationPath(): string {
    return this.#path;
  }
}
